import React from "react";
import { openaiIcon } from "../../utils/config";
import type { TranslateButtonModel } from "../../type/buttons";
import "./translateButton.scss";


export const TranslateButton: React.FC<TranslateButtonModel> = ({
  onClick,
  disabled = false,
  loading = false,
  title = "Translate",
}) => (
  <span className="translate-button-wrapper">
    <button
      type="button"
      className="translate-button btn btn-link btn-sm ms-2 p-0 align-baseline"
      style={{ fontSize: "0.95em" }}
      onClick={onClick}
      disabled={disabled || loading}
      title={loading ? "Translating…" : title}
    >
      {loading ? (
        <span
          className="spinner-border spinner-border-sm"
          role="status"
          aria-label="Translating"
        />
      ) : (
        openaiIcon
      )}
    </button>
  </span>
);